const initialState = {
  tagPanelVisible: false
}


export const tagPanelReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_TAGPANEL": {
      return { ...state, tagPanelVisible: action.data }
    }

    default:
      return state;

  }
};